
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M14.411 8.029L15.85 6.59a.5.5 0 000-.707l-.707-.707a.5.5 0 00-.707 0l-1.439 1.439-1.434-1.434a.5.5 0 00-.707 0l-.707.707a.5.5 0 000 .707l1.434 1.434-1.434 1.434a.5.5 0 000 .707l.707.707a.5.5 0 00.707 0l1.434-1.434 1.439 1.439a.5.5 0 00.707 0l.707-.707a.5.5 0 000-.707l-1.439-1.439zM8.041.136L4 4.007H1c-.553 0-1 .484-1 1.026v5.952c0 .542.447 1.021 1 1.021h3l4.062 3.904S9 16.472 9 14.845V1.108C9-.536 8.041.136 8.041.136z"}})])
      }
    
      }
    